module.exports = __webpack_public_path__ + "files/705742410511a4764c2aceac7a5ef914.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/favicon-96x96.png
// module id = 1251
// module chunks = 76